import { useCallback, useEffect, useRef, useState } from "react";
import * as catalogAPI from "../../services/catalog";

/**
 * Loads the device catalog and returns its entries plus error/reload
 * controls. Callers fall back to the fixed decoders (CayenneLPP, Custom)
 * when `error` is true; `reload()` tries again.
 */
export default function useCatalogEntries() {
  const [entries, setEntries] = useState([]);
  const [error, setError] = useState(false);
  const mountedRef = useRef(true);

  const load = useCallback(async () => {
    try {
      const data = await catalogAPI.list();
      if (mountedRef.current) {
        setEntries(data);
        setError(false);
      }
    } catch (err) {
      if (mountedRef.current) {
        setError(true);
      }
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    load();
    return () => {
      mountedRef.current = false;
    };
  }, [load]);

  return { entries, error, reload: load };
}
